//Angular

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ScrapAgentListComponent } from './scrapAgentList.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoaderModule } from '../../shared/loader/loader.module';
import { ScrapAgentRoutingModule } from './scrapAgent-routing.module';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      NgxPaginationModule,
      LoaderModule,
      ModalModule.forRoot(),
      ReactiveFormsModule,
      ScrapAgentRoutingModule
  
    ],
    declarations: [
      ScrapAgentListComponent
      
  
    ]
  
  })
  export class scrapAgentModule { }
  
